module.exports = __webpack_public_path__ + "assets/img/kv-6258f9ba.jpg";